
import { defineComponent, PropType } from "vue";
import { Message } from "@/controller/chat";
import MessageBalloon from "./MessageBalloon.vue";
import ImageViewer from "./ImageViewer.vue";

export default defineComponent({
  name: "ChatMessages",

  components: {
    MessageBalloon,
    ImageViewer
  },

  props: {
    messages: {
      type: Array as PropType<Message[]>,
      required: true
    }
  },

  data() {
    return {
      isViewingImage: false,
      viewingImage: "",
      lastMessagesLength: 0
    };
  },

  watch: {
    messages(newMessages: Message[]) {
      const newMessagesLength = newMessages.length;

      if (newMessagesLength > this.lastMessagesLength) {
        this.lastMessagesLength = newMessagesLength;
        const lastMessage = newMessages[newMessagesLength - 1];

        if (lastMessage.isFromCustomer) {
          this.$nextTick(() => {
            this.scrollChatToBottom();
          });
        }
      }
    }
  },

  mounted() {
    this.scrollChatToBottom();
  },

  methods: {
    showImageViewer(selectedImage: string) {
      this.isViewingImage = true;
      this.viewingImage = selectedImage;
    },

    scrollChatToBottom() {
      document.getElementById("lastMessage")?.scrollIntoView();
    }
  }
});
